import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Search} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {updateManualEntryBreakSearchAction} from "./actions";
import {makeDBContentImageUrl} from "../../utils/DBUtils";

const BreakSearchInput = ({showField, loading, update, onValueChanged, results, text, placeholder}) => {
    const resultItems = results.map(result => ({
        title: `${result.title} - ${result.platform}`,
        image: makeDBContentImageUrl(result.cardImageId),
        permalink: result.permalink,
        id: result.id
    }));

    // TODO: Move showing of field based on prop to common HOC or into ResourceForm
    return showField ? (
        <div className="break-search-field">
            <div>
                <i className='asterisk icon inline'></i>
                <FormattedMessage id='prizes.manual.entry.breakId' />
            </div>
            <Search
                loading={loading}
                placeholder={placeholder}
                onResultSelect={(event, data) => onValueChanged(data.result.id)}
                onSearchChange={({target}) => update(target.value)}
                results={resultItems}
                value={text}
            />
        </div>
    ) : "";
};

BreakSearchInput.propTypes = {
    loading: PropTypes.string,
    canCreate: PropTypes.string,
    update: PropTypes.string,
    select: PropTypes.string,
    results: PropTypes.string,
    text: PropTypes.string,
    placeholder: PropTypes.string,
};

const mapState = ({listEntries}) => {
    return {
        results: listEntries.breakSearchResults
    };
};

const mapDispatch = (dispatch) => {
    return {
        update: (value) => dispatch(updateManualEntryBreakSearchAction(value))
    };
};

export default connect(mapState, mapDispatch)(BreakSearchInput);


// WEBPACK FOOTER //
// ./public/pages/ListEntries/BreakSearchInput.jsx